import { useContext, useMemo } from 'react';
import { Flex } from '@mantine/core';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { PEOPLE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { PageAbsoluteContainer } from '@dealstack/frontend/shared/layout/PageAbsoluteContainer/PageAbsoluteContainer.tsx';
import { PageHeader } from '@dealstack/frontend/shared/layout/PageHeader/PageHeader.tsx';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { AuditView } from '@dealstack/frontend/shared/components/Audit/Audit.tsx';
import {
	AuditContext,
	useAuditController,
} from '@dealstack/frontend/shared/components/Audit/useAuditController.ts';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { DIRECTORY_BREADCRUMBS } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/shared/directoryBreadcrumbs.tsx';

export const PersonHistoryPage = () => {
	const tCapManage = useTranslationCapManage();
	const { selectedEntityId, selectedEntityData, dealId } = useContext(CapManageControllerContext);

	const personId = selectedEntityId;
	const personDisplayName = selectedEntityData?.displayName ?? '';

	const auditEndpoint = formatUnicorn(API_PATHS.AUDIT_PERSON_PERSONID_GET, {
		personId,
	});
	const auditController = useAuditController(personId, auditEndpoint);

	const breadcrumbs = useMemo(
		() =>
			DIRECTORY_BREADCRUMBS[PEOPLE_ROUTES.PERSON_HISTORY]({
				tCapManage,
				dealId: dealId ?? '',
				personId,
				personDisplayName,
			}),
		[tCapManage, dealId, personId, personDisplayName]
	);

	useBreadcrumbs(breadcrumbs);

	return (
		<PageAbsoluteContainer>
			<PageHeader
				pageTitle={
					personDisplayName
						? tCapManage('people.history.page_title', {
								defaultValue: "History - {{name}}'s Basic Details",
								name: personDisplayName,
							})
						: tCapManage('people.history.page_title_fallback', {
								defaultValue: 'History - Basic Details',
							})
				}
			/>

			<Flex direction="column" w="100%" style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
				<AuditContext.Provider value={auditController}>
					<AuditView />
				</AuditContext.Provider>
			</Flex>
		</PageAbsoluteContainer>
	);
};
